import { createTenantOrganisation } from '@infuse/api/iam/tenant';
import { useGenericCreateOrganisation } from '@infuse/iam/organisation/mutations';

export const useCreateTenantOrganisation = () =>
  useGenericCreateOrganisation({
    apiFn: createTenantOrganisation
  });
